import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import "./style.css";

interface SpinnerIconProps {
    className?: string;
}

export const SpinnerIcon = ({ className }: SpinnerIconProps) => {
    return (
        <FontAwesomeIcon
            icon={faCircleNotch as IconProp}
            className={classNames([
                "fa-spin",
                "fa-pulse",
                "c-SpinnerIcon",
                className,
            ])}
        />
    );
};
